import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Inject,
  inject
} from '@angular/core';
import maplibregl, { Map, Marker } from 'maplibre-gl';
import { HttpClient } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { Subject, Subscription, debounceTime } from 'rxjs';

@Component({
  selector: 'app-place-picker',
  standalone: false,
  // imports: [FormsModule, CommonModule],
  templateUrl: './place-picker.component.html',
  styleUrl: './place-picker.component.css'
})
export class PlacePickerComponent implements OnInit {
  @ViewChild('mapContainer', { static: true }) mapContainer!: ElementRef;
  map!: Map;
  marker!: Marker;
  searchQuery = '';
  pickedCoordinates: { lat: number, lng: number } | null = null;

  dialogRef = inject(MatDialogRef<PlacePickerComponent>);
  data = inject(MAT_DIALOG_DATA);
  http = inject(HttpClient);

  ngOnInit() {
    const defaultLng = 77.209;
    const defaultLat = 28.6139;
console.log(this.data);
    this.map = new maplibregl.Map({
      container: this.mapContainer.nativeElement,
      style: 'https://basemaps.cartocdn.com/gl/voyager-gl-style/style.json',
      center: [defaultLng, defaultLat],
      zoom: 5
    });


    //  Center map based on city from data (if provided)
  if (this.data?.city) {
    const url = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(this.data.city)}`;
    this.http.get<any[]>(url).subscribe((results) => {
      if (results.length > 0) {
        const lat = parseFloat(results[0].lat);
        const lon = parseFloat(results[0].lon);
        this.map.flyTo({ center: [lon, lat], zoom: 12 });
        this.placeMarker(lon, lat);
        this.pickedCoordinates = { lat, lng: lon };
      }
    });
  } else 
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const lng = position.coords.longitude;
          const lat = position.coords.latitude;
          this.map.flyTo({ center: [lng, lat], zoom: 14 });
          this.placeMarker(lng, lat);
          this.pickedCoordinates = { lat, lng };
        },
        (err) => {
          console.warn('Geolocation failed, using default location.', err);
        }
      );
    }

    this.map.on('click', (e) => {
      const lng = e.lngLat.lng;
      const lat = e.lngLat.lat;
      this.pickedCoordinates = { lat, lng };
      this.placeMarker(lng, lat);
    });
    this.searchSubscription = this.searchSubject
    .pipe(debounceTime(400)) // wait 400ms after typing stops
    .subscribe((query: string) => {
      this.searchPlace(this.searchQuery);
    });

  }

  placeMarker(lng: number, lat: number) {
    if (this.marker) this.marker.remove();
    this.marker = new maplibregl.Marker().setLngLat([lng, lat]).addTo(this.map);
  }

  searchPlace(query:string) {
    if (!query) return;
    const url = `https://nominatim.openstreetmap.org/search?format=json&q=${this.searchQuery}`;

    this.http.get<any[]>(url).subscribe((results) => {
      if (results.length > 0) {
        const result = results[0];
        const lat = parseFloat(result.lat);
        const lon = parseFloat(result.lon);
        this.map.flyTo({ center: [lon, lat], zoom: 14 });
        this.pickedCoordinates = { lat, lng: lon };
        this.placeMarker(lon, lat);
      } else {
        alert('Place not found');
      }
    });
  }

  private searchSubject = new Subject<string>();
  private searchSubscription!: Subscription;


  onSearchChange(query: string) {
    this.searchSubject.next(query);
  }
 

  close() {
    this.dialogRef.close();
  }

  selectLocation() {
    if (this.pickedCoordinates) {
      this.dialogRef.close(this.pickedCoordinates);
    }
  }
  ngOnDestroy() {
    this.searchSubscription.unsubscribe();
  }
}
